module.exports = __webpack_public_path__ + "img/item-1-1.3e7f683a.png";